export default "__VITE_ASSET__C941Ztlo__"